import { useState } from "react";
import { accountService, homeService } from "@miplatform/api";
import { DEFAULT_PAGE_SIZE, HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState, useDebounce } from "@miplatform/hooks";
import { buildSearchQuery, createUUID } from "@miplatform/utils";

let GET_HOMES_UUID = createUUID();
let GET_ACCOUNTS_UUID = createUUID();

export const useHomeAndAccountSearchViewModel = ({ homeFilters = {} }) => {
  const [search, setSearch] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [homes, setHomes] = useState([]);

  const stateManager = useComponentState();
  const debouncedSearch = useDebounce(search);

  const getHomes = () => {
    stateManager.abort(GET_HOMES_UUID);
    GET_HOMES_UUID = createUUID();

    return stateManager.run(async (signal) => {
      const searchQuery = buildSearchQuery(debouncedSearch, [
        "address.addressLine1",
        "accountName",
      ]);
      const { data, status } = await homeService.homes.getAll({
        filters: {
          ...searchQuery,
          ...homeFilters,
        },
        sort: "address/addressLine1 asc",
        top: DEFAULT_PAGE_SIZE,
        signal,
      });

      if (status === HTTP_STATUSES.OK) {
        setHomes(data);
      }
    }, GET_HOMES_UUID);
  };

  const getAccounts = (filterByAccountTypes = []) => {
    stateManager.abort(GET_ACCOUNTS_UUID);
    GET_ACCOUNTS_UUID = createUUID();

    return stateManager.run(async (signal) => {
      const searchQuery = buildSearchQuery(debouncedSearch, ["name"]);
      const { status, data } = await accountService.accounts.getAll({
        filters: {
          ...(filterByAccountTypes.length && {
            accountType: { in: filterByAccountTypes },
          }),
          ...searchQuery,
        },
        sort: "name asc",
        top: DEFAULT_PAGE_SIZE,
        signal,
      });
      if (status === HTTP_STATUSES.OK) {
        setAccounts(data);
      }
    }, GET_ACCOUNTS_UUID);
  };

  return {
    accounts,
    search,
    debouncedSearch,
    homes,
    setSearch,
    getHomes,
    getAccounts,
  };
};
